/**
 * Ryan O'Dowd
 * 2022-11-28
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';

const i18n = (localeId) => { // @TODO: this should be an object that throws an error if a key is missing (one of the supported languages) // @TODO: make sure error is thrown even when i18n is moved to the back end
  const words = {
    impactBody: {
      1: (msSpent, versesReviewed, styles) => <Text style={styles}>Wrinkly users have spent over {msSpent} reviewing more than {versesReviewed}.</Text>,
      2: (msSpent, versesReviewed, styles) => <Text style={styles}>Usuarios de Wrinkly gastaban más de {msSpent} mientras revisaba más de {versesReviewed}.</Text>,
      3: (msSpent, versesReviewed, styles) => <Text style={styles}>Wrinkly-Benutzer haben über {msSpent} damit verbracht, mehr als {versesReviewed} zu rezensieren.</Text>,
    },
    yearInReviewLessons: { // @TODO: include longest streak?
      1: (numLessonsJsx, daysWithLessonsJsx, styles) => <Text style={styles}>You completed {numLessonsJsx} in {daysWithLessonsJsx}.</Text>, // @TODO: {Math.floor(lessonsPerDay) > 1 ? `  (That's ${Math.floor(lessonsPerDay) !== Math.ceil(lessonsPerDay) && 'more than '}` : null}<Text style={styles.statText}>{Math.floor(lessonsPerDay)}</Text> lessons per day!)
    },
    yearInReviewTime: {
      1: (msSpentJsx, numVersesJsx, peanutsEarnedJsx, styles) => <Text style={styles}>You spent {msSpentJsx} reviewing more than {numVersesJsx} and earned {peanutsEarnedJsx}{".  Great job spending time in God's Word!"}</Text>,
    },
    yearInReviewGoalsAndWrinkles: {
      1: (numGoalsWorkedOnJsx, numWrinklesEarnedJsx, numWrinklesEarned, numWrinklesEarnedUnits, numWrinklesInProgress, numVersesRecitedSuccessfullyJsx, styles) => {
        return (
          <Text style={styles}>
            You worked on {numGoalsWorkedOnJsx} this year{!numWrinklesEarned ? '.' : <> and earned {numWrinklesEarnedJsx}.  That&apos;s {numWrinklesEarned.toLocaleString()} memorized {numWrinklesEarnedUnits}!</>}
            {!!numWrinklesInProgress && <>  (And you have {numWrinklesInProgress} in progress...keep up the good work!)</>}
            {!!numVersesRecitedSuccessfullyJsx && <>  You successfully recited {numVersesRecitedSuccessfullyJsx} this year.</>}
          </Text>
        );
      },
    },
    yearInReviewMiscFriends: {
      1: (numFriendsJsx, isPublic, styles) => <Text style={styles}>Great job with accountability; {numFriendsJsx} are using Wrinkly with you.{!isPublic && '  Share your year-end review with them!'}</Text>, // @TODO: make this interactive, reword, and also have alternative text if _stats.num_friends === 0 // @TODO: styles isn't passed in in either usage
    },
    yearInReviewMiscDays: {
      1: (daysWithLessonsJsx, styles) => <Text style={styles}>You completed a lesson on {daysWithLessonsJsx} this year!</Text>,
    },
    yearInReviewShareMessage: {
      1: (year, url) => `I've been using Wrinkly to memorize Scripture.  See what I accomplished in ${year}!  ${url}`,
    },
    yearInReviewLifetime: { // @TODO: include longest streak? include current streak?
      1: (userJoinYear, numLifetimePeanutsJsx, numLifetimeWrinklesJsx, styles) => <Text style={styles}>Since joining Wrinkly on {userJoinYear}, you have earned a total of {numLifetimePeanutsJsx} and {numLifetimeWrinklesJsx}.</Text>,
    },
    yearInReviewGlobal: {
      1: (numMsSpentJsx, numVersesReviewedJsx, styles) => <Text style={styles}>In total, Wrinkly users have collectively spent over {numMsSpentJsx} reviewing more than {numVersesReviewedJsx}.</Text>,
    },
    forgotPassword: { // @TODO: should this be in db, too?
      1: 'Forgot password',
    },
    // @NOTE: local development only; nothing in here should make it to prod: {
    finishAssignment: {
      1: 'Finish', // @TODO: would prefer something less academic than "assignment" or "lesson" for users who aren't in a classroom
    },
    myGroupGoals: {
      1: 'My group goals', // @TODO: would like a different name than this...
    },
    yearInReviewEmptyScreenText: {
      1: 'Great progress this year!  View your progress here.', // @TODO: better wording
    },
    sort: {
      1: 'Sort',
    },
    groupByTranslation: {
      1: 'Group by translation',
    },
    chronological: {
      1: 'Chronological',
    },
    showInProgressFirst: {
      1: 'Show in progress first',
    },
    showLevelNumbers: {
      1: 'Show level numbers',
    },
    groupAdjacentVerses: {
      1: 'Group adjacent verses',
    },
    hideWaitingForLevelUp: {
      1: 'Hide waiting for level up',
    },
    hidePaused: {
      1: 'Hide paused',
    },
    options: {
      1: 'Options',
    },
    dateLastLeveledUp: {
      1: 'Date last leveled up',
    },
    dateOfNextLevelUp: {
      1: 'Date of next level up',
    },
    levelNumber: {
      1: 'Level number',
    },
    noInternet: {
      1: (message) => `No internet connection.${message ? ` ${message}` : ''}`,
    },
    searchFunctionalityLimited: {
      1: 'Search functionality may be limited.',
    },
    searchFunctionalityDisabled: {
      1: 'Search functionality disabled.',
    },
    offlineTryAgain: {
      1: 'Try again when back online.',
    },
    offlineVerses: {
      1: 'Some verses could not be loaded. Full translations can be downloaded from the Settings page for offline use when back online.',
    },
    networkRequiredForAuth: {
      1: 'A network connection is required for signing in; please connect to the internet and try again.',
    },
    // @NOTE: local development only; nothing in here should make it to prod: }
  };

  const localeWords: any = {};
  Object.entries(words).forEach(([key, value]) => {
    localeWords[key] = value[localeId] || value[1];
  });

  return localeWords;
};

export default i18n;

export const i18nUnitsTime = {
  2: {
    millisecond: 'milisegundo',
    second: 'segundo',
    minute: 'minuto',
    hour: 'hora',
  },
  3: {
    millisecond: 'Millisekunde',
    second: 'Sekunde',
    minute: 'Minute',
    hour: 'Stunde',
  },
};
